import { jsx as _jsx } from "react/jsx-runtime";
import { Children, useMemo, isValidElement } from 'react';
import Tabs from '../tabs';
import useConfig from '../../hooks/useConfig';
var AnchorTabs = function AnchorTabs(_ref) {
  var children = _ref.children,
    className = _ref.className,
    config = _ref.config;
  var bgColor = config.bgColor,
    textColor = config.textColor,
    activeColor = config.activeColor,
    tabType = config.tabType,
    tabs = config.tabs,
    scrollTab = config.scrollTab,
    anchorMap = config.anchorMap;
  var _useConfig = useConfig(),
    downloadBarHeight = _useConfig.downloadBarHeight;
  var childrenMapByAnchor = useMemo(function () {
    var map = {};
    if (anchorMap) {
      var childrenMap = {};
      Children.forEach(children, function (child) {
        var _a;
        if ( /*#__PURE__*/isValidElement(child)) {
          var componentId = (_a = child.props) === null || _a === void 0 ? void 0 : _a.id;
          if (componentId) {
            childrenMap[componentId] = child;
          }
        }
      });
      return Object.entries(anchorMap).reduce(function (initival, _ref2) {
        var key = _ref2[0],
          value = _ref2[1];
        initival[parseInt(key)] = value.map(function (id) {
          return childrenMap[id];
        });
        return initival;
      }, map);
    }
    return map;
  }, [children, anchorMap]);
  var renderTitle = function renderTitle(isActive, index) {
    var _a, _b, _c, _d;
    var item = tabs[index];
    return tabType === 'img' ? _jsx("img", {
      src: isActive ? (_b = (_a = item === null || item === void 0 ? void 0 : item.tabImage) === null || _a === void 0 ? void 0 : _a[1]) === null || _b === void 0 ? void 0 : _b.url : (_d = (_c = item === null || item === void 0 ? void 0 : item.tabImage) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.url,
      alt: ""
    }) : item === null || item === void 0 ? void 0 : item.tabName;
  };
  return _jsx(Tabs, Object.assign({
    type: tabType,
    color: activeColor,
    scrollable: scrollTab,
    className: className,
    background: bgColor,
    titleInactiveColor: textColor,
    titleActiveColor: textColor,
    offsetTop: downloadBarHeight
  }, {
    children: tabs.map(function (item, index) {
      return _jsx(Tabs.TabPane, Object.assign({
        title: function title(isActive) {
          return renderTitle(isActive, index);
        }
      }, {
        children: childrenMapByAnchor[index]
      }), index);
    })
  }));
};
AnchorTabs.displayName = 'AnchorTabs';
AnchorTabs.defaultProps = {
  config: {
    tabs: [],
    tabType: 'text',
    scrollTab: false
  }
};
export default AnchorTabs;